import type { PDFReader } from "./PDFReader"

export type PDFWriter = {
  insert(source: PDFReader, insert_at: number): Promise<void>
  save(): AsyncGenerator<Blob>
  close(): Promise<void>
}
